import { Injectable } from '@angular/core';
import { VisibaApiHttp } from '../../../Classes/visibaHttp.class';
import { AppointmentApiModel } from './Models/AppointmentApiModel';

@Injectable()
export class AppointmentsServiceV2 {
	readonly baseUri = '/api/Client/v2/Appointments';

	constructor(private http: VisibaApiHttp) {}

	public getAll() {
		return this.http.getTyped<AppointmentApiModel[]>(this.baseUri);
	}

	public get(ticket: Guid) {
		return this.http.getTyped<AppointmentApiModel>(`${this.baseUri}/${ticket}`);
	}

	public cancel(ticket: Guid) {
		return this.http.delete(`${this.baseUri}/${ticket}`);
	}

	public getFileIdentifier(ticket: Guid, name: string, length: number, type: string) {
		const sendData = {
			Name: name,
			Length: length,
			Type: type === '' ? this.resolveMimeType(name) : type,
		};

		return this.http.post(`${this.baseUri}/${ticket}/files`, sendData);
	}

	private resolveMimeType(fileName: string) {
		const extension = fileName.split('.')[fileName.split('.').length];
		switch (extension) {
			case 'doc':
				return 'application/msword';
			case 'docx':
				return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
			default:
				return 'application/octet-stream';
		}
	}
}
